import React from "react";
import type { CustomPropsJson, Element } from "./types";
import SectionInput from "./SectionInput";
import DynamicSectionInput from "./DynamicSectionInput";
type SectionElementsProps = {
  elements: Element[];
  disabled?: boolean;
  isPreviewOnly?: boolean;
  replaceMarkersData?: Record<string, string | undefined>;
  institutionSlug: string | undefined;
  readonly?: boolean;
};
function SectionElements({
  elements,
  disabled = false,
  replaceMarkersData,
  isPreviewOnly,
  institutionSlug,
  readonly
}: SectionElementsProps) {
  const getDynamicDependentElement = (element: Element) => {
    const validator = element.element.validators?.find(validator => validator.validator.type === "CLIENT_SIDE_DYNAMIC");
    if (!validator) {
      return null;
    }
    return elements.find(element => element.element.identifier === validator.validator.options?.elementId);
  };
  const isElementRequired = (element: Element) => {
    const validator = element.element.validators.find(validator => validator.validator.type === "REQUIRED");
    return !!validator;
  };
  const isDynamicInput = (element: Element) => !!getDynamicDependentElement(element);
  return <div className="@container" data-sentry-component="SectionElements" data-sentry-source-file="SectionElements.tsx">
      <div className="@sm:grid-cols-6 @md:grid-cols-8 @lg:grid-cols-12 grid grid-cols-1 
                     gap-x-4 
                     gap-y-1
                     px-1">
        {elements.map(elementSection => {
        const displayName = isElementRequired(elementSection) ? `${elementSection.element.displayName} *` : elementSection.element.displayName;
        const placeholder = !elementSection.element.placeholder ? isElementRequired(elementSection) ? `${elementSection.element.displayName} *` : elementSection.element.displayName : elementSection.element.placeholder;
        return !isDynamicInput(elementSection) ? <div className="@sm:col-span-6 @md:col-span-4 @lg:col-span-3">
              <SectionInput disabled={disabled} key={elementSection.id} isPreviewOnly={isPreviewOnly} element={{
            ...elementSection.element,
            id: elementSection.id,
            displayName,
            placeholder,
            customPropsJson: elementSection.customPropsJson
          }} replaceMarkersData={replaceMarkersData} institutionSlug={institutionSlug} readonly={readonly} />
            </div> : <div className="@sm:col-span-6 @md:col-span-4 @lg:col-span-3">
              <DynamicSectionInput key={elementSection.id} element={{
            ...elementSection,
            element: {
              ...elementSection.element,
              id: elementSection.id,
              displayName,
              placeholder,
              customPropsJson: elementSection.customPropsJson as CustomPropsJson
            }
          }} dependentElement={getDynamicDependentElement(elementSection)} institutionSlug={institutionSlug} disabled={disabled} isPreviewOnly={isPreviewOnly} />
            </div>;
      })}
      </div>
    </div>;
}
export default SectionElements;